
import styled from 'styled-components';

import { userHasAccess } from '../../../supplementary_components/userDataDelegate';
import {addPopup} from '../../../supplementary_components/store';
import { Form } from '../../forms/Form';
import { setCompany } from '../../../supplementary_components/companySettings';
import { COMPANY_ADD_CONF } from '../../../pages/company/comapnyAddConf';

const Wrapper = styled.div`
    width: 100%;
    height:50vh;
    display:flex;
    justify-content:center;
    align-items:center;
    div{
        background-color:var(--main-color);
        padding: 1rem;
        border-radius: 0.8rem;
        color:white;
        font-weight:bold;
        font-size: 1.2rem;
        cursor:pointer;
    }
`;

export const NoCompany = ()=> {
    
    const companyConf = COMPANY_ADD_CONF;
    // <div>{ViewStructure.addButton && userHasAccess(ViewStructure.addConf.formAccessLevel)  ? <span onClick={()=>{addPopup({content:Form, popupData:{configuration: ViewStructure.addConf}, postSuccessAction: RequstReload, EZCloseAllowed:ViewStructure.EZCloseAllowed})} }>Add {ViewStructure.dataTitle} +</span> : null}</div>
    
    return <Wrapper>
        <div onClick={()=>{
                if (userHasAccess(companyConf.formAccessLevel)){
                    addPopup({content:Form, popupData:{configuration: companyConf}, postSuccessAction: (e)=>{
                        setCompany(e); 
                        document.location.reload();
                }, EZCloseAllowed:false})
                }
            }}>
            Add Company
        </div>
    </Wrapper>
}